import isNil from 'lodash/isNil';

const validateAccount = account => {
  const errors = [];

  if (!isNil(account.AccountType)) {
    // required fields
    if (!account.NonSpecificPositionsValue) {
      errors.push(['Please provide a valid value for this account.']);
    }

    if (!account.AccountName) {
      errors.push(['Please provide a valid description for this account.']);
    }
  } else if (!isNil(account.OtherAssetType)) {
    switch (account.OtherAssetType) {
      case 0: // Business Asset
        if (!account.UseUnderlyingAssetsForValue && !account.Value) {
          errors.push(['Please provide a valid market value for this account.']);
        }

        if (!account.Name) {
          errors.push(['Please provide a valid business name for this account.']);
        }
        break;
      case 1: // Real Estate Asset
        if (!account.MarketValue) {
          errors.push(['Please provide a valid market value for this account.']);
        }

        if (!account.Name) {
          errors.push(['Please provide a valid property name for this account.']);
        }
        break;
      case 3: // Misc Asset
        if (!account.MarketValue) {
          errors.push(['Please provide a valid value for this account.']);
        }

        if (!account.Name) {
          errors.push(['Please provide a valid description for this account.']);
        }
        break;
      case 4: // Deferred Compensation
        if (!account.Value) {
          errors.push(['Please provide a valid value for this account.']);
        }

        if (!account.Name) {
          errors.push(['Please provide a valid description for this account.']);
        }
        break;
      default:
    }
  }

  return errors;
};

export default validateAccount;
